import mixpanel from 'mixpanel-browser';

export const initMixpanel = () => {
  try {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN, {
      api_host: process.env.REACT_APP_MIXPANEL_API_HOST,
      debug: false,
      ignore_dnt: true,
    });
  } catch (e) {
    reportError('Failed to initialize Mixpanel');
  }
};

export const trackEvent = (key, options = {}) => {
  try {
    mixpanel.track(key, options);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Failed to track event', e);
  }
};
